import React, { useState, useEffect } from 'react'
import axios from 'axios'

import Loader from '../../Loader/Loader';
import EventCard from './EventCard';
import './Events.css'

const EVENT_URL = "/events"


function Events() {

  const [events, setEvents] = useState('')

  useEffect(() => {
    async function getEvents() {
      try {
        const response = await axios.get(process.env.REACT_APP_DEPT_API + EVENT_URL);
        setEvents(response.data);
      } catch (error) {
        console.error(error);
      }
    }
    getEvents()
  }, [])

  var currentDate = new Date()

  const pastEvents = events && events.filter(x => new Date(x.event_date) < currentDate)
  const upcomingEvents = events && events.filter(x => new Date(x.event_date) >= currentDate)
  // const upcomingEvents = events && events.filter(item => !pastEvents.includes(item));


  return (
    <div className='events'>
      <div className='section__container'>
        <div className='section'>
          <p className='about__p mt-2'>
            The Department places a great deal of emphasis on Technical Events and provides a platform for young minds to display their skills and compete with like-minded individuals, with the best talent winning.
          </p>
          <h1 className='section__header'>Upcoming Events</h1>
          <div className='events__container'>
            {upcomingEvents ? upcomingEvents.map((eve) => (
              <EventCard
                key={eve._id}
                club={eve.club}
                collaborating_clubs={eve.collaborating_clubs}
                description={eve.description}
                event_date={eve.event_date}
                organizing_club={eve.organizing_club}
                poster_image={eve.poster_image.url}
                registration_deadline={eve.registration_deadline}
                registration_link={eve.registration_link}
                title={eve.title}
                venue={eve.venue}
                concluded={false}
              />
            )) : <Loader color="#AE9142" size={70} />}
            {!upcomingEvents.length > 0 && (
              <p className='about__p'>No upcoming events</p>
            )}
          </div>
        </div>
        <div className='section'>
          <h1 className='section__header'>Past Events</h1>
          <div className='events__container'>
            {pastEvents ? pastEvents.map((eve) => (
              <EventCard
                key={eve._id}
                club={eve.club}
                collaborating_clubs={eve.collaborating_clubs}
                description={eve.description}
                event_date={eve.event_date}
                organizing_club={eve.organizing_club}
                poster_image={eve.poster_image.url}
                registration_deadline={eve.registration_deadline}
                registration_link={eve.registration_link}
                title={eve.title}
                venue={eve.venue}
                concluded={true}
              />
            )) : <Loader color="#AE9142" size={70} />}
            {!pastEvents.length > 0 && (
              <p className='about__p'>No past events</p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Events